import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as referencesActions from '../../../redux/actions/ReferencesActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import Modal from '../../commonComponents/util/Modal';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import AutocompleteInput from '../../commonComponents/util/AutocompleteInput';
import ReferenceModal from '../../recipientAccountsComponents/references/ReferenceModal';
import { formatReferenceOptions } from '../../../lib/utils';

class AddReferenceModal extends NavigationComponent {

    initialState = {
        referenceId: null,
        relationship: '',
        submitAttempted: false,
        showModals: {
            newReferenceModal: false
        }
    };

    constructor(props) {
        super(props);

        this.state = this.initialState;
    }

    onChange = (name, value) => {
        this.setState({ [name]: value });
    }

    onClose = () => {
        this.props.close();
        this.setState(this.initialState);
    }

    onSubmit = () => {
        this.setState({ submitAttempted: true });

        const { referenceId, relationship } = this.state;
        if (referenceId) {
            const reference = this.props.references.data[this.props.references.data.map(ref => ref.referenceId).indexOf(referenceId)];
            this.props.addReference({ ...reference, relationship });
            this.onClose();
        }
    }

    createReference = async reference => {
        await this.props.actions.createReference(reference);
        if (this.props.createReference.success) {
            await this.props.actions.getAllReferences();
            this.setState({ referenceId: this.props.createReference.data });
        }
    }

    render() {
        const { referenceId, relationship, submitAttempted } = this.state;
        const { references, filterReferences, referenceType } = this.props;

        return (
            !this.state.showModals.newReferenceModal ? <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Add {referenceType}</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose} />
                        </div>
                        <div className="modal-section">
                            <div className="modal-row full-width-modal-row">
                                <ValidatedInput input={<AutocompleteInput
                                    placeholder="Search references"
                                    loading={references.loading}
                                    options={formatReferenceOptions(references.data.filter(filterReferences))}
                                    update={this.onChange}
                                />}
                                    label={referenceType}
                                    name="referenceId" value={referenceId}
                                    required={true} showRequiredError={submitAttempted} />
                                <div style={{marginLeft: "16px", width: "auto"}}>
                                    <label className="input-label"></label>
                                    <button className="btn btn-accent2"
                                    onClick={this.toggleModal.bind(this, "newReferenceModal")}>
                                    <i className="icon ion-ios-plus-empty icon-left"></i>Create</button>
                                    </div>
                            </div>
                            <div className="modal-row full-width-modal-row">
                                <ValidatedInput input={<input type="text" />}
                                    label="Relationship To Recipient"
                                    name="relationship"
                                    value={relationship}
                                    onChange={this.onChange}
                                    required={true} showRequiredError={submitAttempted} />
                            </div>
                        </div>
                        <div className="modal-btns text-right">
                            <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                            <button className="btn btn-primary" onClick={this.onSubmit} disabled={!referenceId}>Add</button>
                        </div>
                    </div>
                </div>
            </Modal> : <ReferenceModal
                    show={this.state.showModals.newReferenceModal}
                    close={this.toggleModal.bind(this, "newReferenceModal")}
                    {...this.props.createReference}
                    loading={this.props.createReference.loading || this.props.references.loading}
                    submitReference={this.createReference}
                    usPersonTitles={this.props.usPersonTitles}
                    israelPersonTitles={this.props.israelPersonTitles}
                    usInstitutionTitles={this.props.usInstitutionTitles}
                    israelInstitutionTitles={this.props.israelInstitutionTitles}
                    recipientTypes={this.props.recipientTypes} />
        );
    }
}

function mapStateToProps(state) {
    return {
        references: state.references.references,
        createReference: state.references.createReference,
        usPersonTitles: state.settings.systemSettings.data.recipientSettings.usPersonTitles,
        israelPersonTitles: state.settings.systemSettings.data.recipientSettings.israelPersonTitles,
        usInstitutionTitles: state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,
        israelInstitutionTitles: state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,
        recipientTypes: state.settings.systemSettings.data.otherSettings.recipientTypes
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(referencesActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddReferenceModal);


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/AddReferenceModal.jsx